// JS Files

// Cookie Consent & Iframes - choose which solution to use

import './lib/iframemanager.js';
import './components/iframemanager-pressidium-bridge.js';
import './components/faqs.js';
import './components/gravity-forms.js';
import './components/header.js';
import './components/match-height.js';
import './components/product-line-details-grid.js';


// Slider Swiper - Now bundles separately (GULP/esbuild) and imported if required here
document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('[data-swiper]'))
	{
		import('./slider-swiper.min.js')
			.catch(err => console.error('Error loading Swiper bundle:', err));
	}
});